<template>
  <div class="message">
    <div class="content">

      <div class="card">
        <div class="menu flex align-center">
          <div class="title" :class="{active:type == '0'}" @click="changeTitle('0')">全部</div>
          <div class="title" :class="{active:type == '1'}" @click="changeTitle('1')">未使用</div>
          <div class="title" :class="{active:type == '2'}" @click="changeTitle('2')">已使用</div>
          <div class="title" :class="{active:type == '3'}" @click="changeTitle('3')">已过期</div>
        </div>
        <div class="" v-loading="loading">
          <div class="flex align-center justify-between padding-tb solid-bottom" v-for="(item,i) in platform" :key='i'>
            <div class="flex align-center">
              <div class="margin-right-10" v-if="item.coupon_data">
                <div class="text-red">￥ <span id="" class="fs24">
                  {{item.coupon_data.reduction_money }}
                </span></div>
                <div class="">满{{ item.coupon_data.threshold_money }}元可减</div>
              </div>
              <div class="">
                <div class=" bold fs16" v-if="item.coupon_data">{{item.coupon_data.instruction }}</div>
                <div class="margin-top-10 text-666">有效期至{{ item.use_end_time }}</div>
              </div>
            </div>
            <div class="">
              <div class="bg-f8 text-666 padding-tb-6 radius-100 width100 text-center" v-if="item.status==2">已使用</div>
              <div class="bg-f8 text-666 padding-tb-6 radius-100 width100 text-center" v-if="item.status==3">已过期</div>
              <div class="bg-theme text-white  padding-tb-6 radius-100 width100 text-center" v-if="item.status==1">未使用</div>
            </div>
          </div>
          <el-empty :image-size="120" v-if="platform.length==0"></el-empty>
          <PageComponents :total="tableShow.listCount" :current="tableShow.currentPage" :pageSize="tableShow.pageSize"
            @on-change="changePage"></PageComponents>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import HeaderComponents from '../../components/header'
  import PageComponents from '../../components/page'

  export default {
    name: 'setting',
    components: {
      HeaderComponents,
      PageComponents
    },
    created() {
      let vm = this
      vm.getPlatform()
    },
    data() {
      return {
				loading: true,
        tableShow: {
          currentPage: 1,
          pageSize: 10,
          listCount: 0
        },
        orderShow: {
          currentPage: 1,
          pageSize: 10,
          listCount: 0
        },
        type: 0, //全部
        platform: [],
        orders: [],
        page: 'platform'
      }
    },
    methods: {
      getPlatform() {
        let vm = this
        vm.platform = []
        this.$request('62b4186ae7914', {
          page: vm.tableShow.currentPage,
          size: vm.tableShow.pageSize,
          type: vm.type,
        }).then(res => {
          const list = (res.data.data && res.data.data.list) || []
          vm.tableShow.listCount = res.data.data.count
          vm.platform = list
          console.log(vm.platform,'vm.platform')
					this.loading = false

        })
      },
      changeTitle(title) {
        this.type = title
        this.tableShow.currentPage = 1
				this.loading = true
        this.getPlatform()
      },
      changePage(page) {
				this.loading = true
        this.tableShow.currentPage = page
        this.getPlatform()
      },

      clickDetail(id) {
        console.log(id)
        this.$router.push({
          name: 'message_detail',
          params: {
            id: id
          }
        })
      }
    }
  }
</script>

<style lang="less">
  .message {
    .ivu-steps-title {
      margin-top: 2px;
    }

    .content {
      background-color: #f7f8fa;
    }

    .card {
      background-color: #FFFFFF;
      padding: 20px;
      border-radius: 3px;

      .menu {
        display: flex;
        justify-content: flex-start;

        .title {
          font-size: 18px;
          color: #333;
          position: relative;
          margin-right: 40px;
          cursor: pointer;


        }

        .active {
          font-weight: 450;
          color: #FB9E2F;

          &::after {
            content: '';
            position: absolute;
            top: 30px;
            left: 0;
            width: 100%;
            height: 3px;
            background-color: #FB9E2F;
          }
        }
      }

      .platform,
      .system {
        margin-top: 40px;
      }
    }
  }
</style>
